import httpRequestAdmin from "./httpRequest/httpRequestAdmin";

class LogService {
  getLogs(params) {
    return httpRequestAdmin.get(process.env.REACT_APP_BACKEND_API_URL + "admin/logs", params);
  }
  deleteLog(params) {
    return httpRequestAdmin.delete(process.env.REACT_APP_BACKEND_API_URL + "admin/logs", params);
  }
}

export default new LogService();
